export const createKey = (keyName: string, prefix: string | null = null): string => {
    if (prefix === null) {
        return keyName;
    }

    return `${prefix}.${keyName}`;
}

export default createKey;